import { useScriptTag } from '@vueuse/core'
import { ref } from 'vue'

declare global {
    interface Window {
        onloadTurnstileCallback: () => void
    }
}

const isTurnstileLoaded = ref(false)

window.onloadTurnstileCallback = () => {
    isTurnstileLoaded.value = true
}

const scriptTag = useScriptTag(
    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onloadTurnstileCallback',
    undefined,
    { immediate: false },
)

export const useCloudflareTurnstile = () => {
    return {
        load: () => scriptTag.load(),
        isTurnstileLoaded,
    }
}
